import React from 'react';
import { useEffect } from 'react';
import '../gral-stylesheets/success.scss';



const SuccessRegister = (props) => {

  useEffect(() => {
    props.joinState || props.loginState || props.passwordResetState || props.successState
      ? document.body.style.overflow = 'hidden'
      : document.body.style.overflow = 'unset'
  }, [props.joinState, props.loginState, props.passwordResetState, props.successState]);

  if (!props.successState) {
    return null
  }
  return (
    <div className='modal-container-overlay'>
      <div className='success-box'>
        <div className='success-header'>
          <div className='svg-box'>
            <svg className='circular green-stroke'>
              <circle className="path" cx="52" cy="52" r="50" fill="none" stroke-width="5" stroke-miterlimit="10" />
            </svg>
            <svg className='checkmark green-stroke'>
              <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
                <path className='checkmark__check' fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53" />
              </g>
            </svg>
          </div>
          <h3>Registered</h3>
          <h4>Your registration has been successful</h4>
        </div>
        <div className='success-button-container'>
          <button>
            <h4 onClick={props.successClose}>
              Ok
            </h4>
          </button>
        </div>
        <div className='success-login'>
          <h3>Do you want login?</h3>
          <p
            onClick={props.toLogin}
          >
            Login here
          </p>
        </div>
      </div>
    </div>
  )

}

export default SuccessRegister;